
/**
 * 黄金-银行金条列表
 */
import merge from "lodash/merge";

interface listConf {
  dataprocessData(data: any): any;
  dataprocess: any;
  ele: String;
  refresh: Number;
  tabconfig: any;
  tabindex: Number;
}

/**
 * @class QuoteList
 * @Title QuoteList`
 * @description 组件封装
 * @params: ele               生成的表格插入的 domid
 * @params: fix                 表格表头是否固顶
 * @params: isrefresh             表格是否支持自刷
 * @params: refresh_time        表格自刷时间间隔(单位 ：毫秒)
 */
class GoldBankList {
  list_config:any = {}
  list_timer: any = null // 定时器
  debounce_timer:any = null
  constructor(options: any) {
    this.list_config = merge(this.list_config, options);
  }

  // 初始化表格 
  async init() {
    let self = this;
    await self.showList();
    await self.refreshData();
  }

  destroy(){
    let self = this;
    clearInterval(self.list_timer)
    $(`#${self.list_config.ele}`).html('')
  }

  showList() {
    let self = this;
    self.makeList();
  }

  // Ajax 请求
  async getDataAjax(url: any) {
    // Ajax数据请求
    let self = this
    let backdata = new Promise(function (res, rej) {
      try {
        $.ajax({
          url: url,
          type: 'GET',
          timeout: 15000,
          dataType: 'jsonp',
          success: function (data) {
            // 返回成功数据
            if (data && data.success) {
              res(data)
            } else {
              rej([]);
            }
          },
          error: function (err) {
            rej([])
          }
        });
      } catch (error) {
        // 错误处理
      }
    })

    return backdata.then(function (v: any) {
      return v
    }).catch(function (ErrMsg: any) {
      return []
    });

  }

  // 生成 list
  async makeList() {
    let self = this;
    let _list = $(`#${self.list_config.ele}`);
    let data = await self.getDataAjax(self.list_config.api)
    let dd = ''
    let result = ''
    if(data.success){
        data.result.data.forEach((item:any) => {
            dd += self.list_config.html(item)
        })
        result = '<dl>' + dd + '</dl>'
    }else{
        let res = self.list_config.error(data)
        result = res
    }
    _list.html(result)
  }

  refreshData(){
      let self = this
      let times = Number(self.list_config.refresh)
      clearInterval(self.list_timer)
      self.list_timer = null 
      if(self.list_config.refresh > 0){
        self.list_timer = setInterval(function () {
            // 刷新前取消滑动动作 防止页面卡死
            self.makeList()
          }, times * 1000)
      }
  }
}

export default GoldBankList